export default {
  // 事件分析相关
  'event_details': "事件详情",
  'event_title': "标题",
  'event_type': "事件类型",
  'event_description': "描述",
  'event_link': "链接",
  'event_creator': "创建者",
  'event_system': "平台",
  'event_info_title': "事件",
  'event_info_start_title': '今日开始事件',
  'event_info_today_title': "今日发生的事件",
  'event_info_events': "条事件",
  'event_info_subtitle': "查看更多事件的详细信息",
  'event_view_link': "点击查看",
  'event_add': '添加',
  
  // 事件添加模态框
  'event_modal_add_event': "添加事件",
  'event_modal_edit_event': "编辑事件",
  'event_modal_title': "标题",
  'event_modal_title_placeholder': "请输入事件标题",
  'event_modal_country': "国家",
  'event_modal_platform': '平台',
  'event_modal_all': '全部',
  'event_modal_country_global': "全球",
  'event_modal_dashboard': "报表",
  'event_modal_dashboard_placeholder': "请选择报表",
  'event_modal_event_type': "事件类型",
  'event_modal_event_type_placeholder': "请选择事件类型",
  'event_modal_description': "描述",
  'event_modal_description_placeholder': "请输入事件描述，如xx活动上线造成活跃上升",
  'event_modal_link': "链接",
  'event_modal_link_placeholder': "请输入相关链接",
  'event_modal_customize_placeholder': "请输入事件类型",
  'event_left_menu_management': '事件管理',
  'event_more': '更多',
  'event_delete_event': '确认删除事件?',
  'event_delete_sure': '是否确认删除{name}？删除后不可恢复，请谨慎操作！',
  'event_delete_success': '删除成功',
  'event_delete_error': '删除失败',
  'event_after_time': '当日最后时刻',
  'event_Actions': '操作',

  'event_add_success': '添加成功',
  'event_edit_success': '编辑成功',
  'event_add_fail': '添加失败',
  'event_edit_fail': '编辑失败',
  'event_selector_global_message': '展示筛选日期内的所有事件',
};
